import request from '@/utils/request'
export function UpdateDid(data) {
  return request({
    url: '/icps/system/sign/cloudSell/engineeringManagement/UpdateDid',
    method: 'post',
    data
  })
}
export function UpdateDidPrice(data) {
  return request({
    url: '/icps/system/sign/cloudSell/engineeringManagement/UpdateDidPrice',
    method: 'post',
    data
  })
}

export function getList(data) {
  return request({
    url: '/icps/system/sign/cloudSell/matching/getList',
    method: 'post',
    data
  })
}
export function saveOrUpdate(data) {
  return request({
    url: '/icps/system/sign/cloudSell/matching/saveOrUpdate',
    method: 'post',
    data
  })
}
/**修改选取配合比 */
export function updateMix(data) {
  return request({
    url: '/icps/system/sign/cloudSell/engineeringManagement/updateMix',
    method: 'post',
    data
  })
}
/**投标附件 */
export function saveDibFile(data) {
  return request({
    url: '/icps/system/sign/cloudSell/engineeringManagement/saveDibFile',
    method: 'post',
    data
  })
}